import { ReactIntlError } from 'react-intl';
import { FormatError } from 'intl-messageformat';
import exceptionTracker from '../exception-tracker';

const errorHandler = (err: ReactIntlError | FormatError): void => {
    exceptionTracker.info(err, window.location.pathname);
}

export default errorHandler;
